import { getLocales } from 'assets/locales/Locale';
import Theme from 'assets/themes/Theme.Common';
import React from 'react';
import { ContractRefundInfoTab, useContractRefundProvider } from '../../Sales.ContractRefund.Hooks';

const titleStyle: React.CSSProperties = { fontSize: Theme.FontSize.L, fontWeight: 'bold' };
const SalesContractRefundInfoNavigation = () => {
  const { lang } = getLocales();
  const { pageRouter, selected, commentsApi } = useContractRefundProvider();

  return (
    <>
      <div
        data-active={pageRouter.query.infoTab === ContractRefundInfoTab.INFO ? true : undefined}
        onClick={() => pageRouter.updateQuery({ ...pageRouter.query, infoTab: ContractRefundInfoTab.INFO })}
        title={lang.showMore}
      >
        <div style={titleStyle}>{lang.info}</div>
        <div>
          {lang.status}:{' '}
          <b>{selected.statusCode ? lang[selected.statusCode]?.replace(/_/g, ' - ') : lang.noStatusDefined}</b>
        </div>
        <br />
        <div>
          {lang.user}: <b>{selected.createdBy?.fullName}</b>
        </div>
        <br />
        {selected.dealer && (
          <>
            <div>
              {lang.dealer}: <b>{selected.dealer.name}</b>
            </div>
            <br />
          </>
        )}
      </div>
      <div
        data-active={pageRouter.query.infoTab === ContractRefundInfoTab.DOCUMENTS ? true : undefined}
        onClick={() => pageRouter.updateQuery({ ...pageRouter.query, infoTab: ContractRefundInfoTab.DOCUMENTS })}
        title={lang.showMore}
      >
        <div style={titleStyle}>{lang.documents}</div>
        <br />
        {lang.refundDocuments}: {(selected?.documentationAggregateId ? 1 : 0).toString()}
        <br />
        {lang.additionalDocumentation}: {selected?.contractRefundDocuments?.length ?? '0'}
      </div>

      <div
        data-active={pageRouter.query.infoTab === ContractRefundInfoTab.NOTES ? true : undefined}
        onClick={() => pageRouter.updateQuery({ ...pageRouter.query, infoTab: ContractRefundInfoTab.NOTES })}
        title={lang.showMore}
      >
        <div style={titleStyle}>{lang.notes}</div>
        <br />
        {lang.notes}: {commentsApi?.payload?.count ?? '0'}
      </div>
    </>
  );
};

export default SalesContractRefundInfoNavigation;
